<template>
  <div class="box box-info">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Work Shift" :visible.sync="displayBasic"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Shift Name<span style="color:red">*</span></label>
            <InputText v-model.trim="name" id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-6"></div>
          <div class="p-field p-col-12 p-md-6">
            <label for="fromTime">Work Hours</label>
            <div class="p-field p-col-12 p-md-6">From</div>
            <DatePicker v-model="fromTime" type="time" id="workhours" valueType="format" :time-picker-options="format"/>
          </div>
          <!--          {{fromTime}}-->
          <div class="p-field p-col-12 p-md-6">
            <label for="toTime"></label>
            <div class="p-field p-col-12 p-md-6 p-mt-2">To</div>
            <DatePicker v-model="toTime" type="time" id="toTime" valueType="format" :time-picker-options="format"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="duration">Duration</label>
            <div id="duration">{{ duration }}</div>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addWorkShift"
                      :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <DataTable :value="workShiftList" :paginator="true" :rows="8" :filters="filters"
    class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.N" field="">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" :sortable="true" field="name" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>
      <Column header="From" :sortable="true" field="startTime" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['startTime']"/>
        </template>
      </Column>
      <Column header="To" :sortable="true" field="endTime" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['endTime']"/>
        </template>
      </Column>
      <Column header="Duration" :sortable="true" field="shiftDuration" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['shiftDuration']"/>
        </template>
      </Column>

      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editWorkShift(slotProps.data)"/>
          <!--        <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success"-->
          <!--                @click="editSalesOrder(slotProps.data)"/>-->
          <!-- Edit button -->
          <!-- DeleteButton -->
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
          <!--        <Button v-else disabled class="p-button-raised p-button-danger"-->
          <!--                @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>-->
          <!-- Delete Button -->
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteWorkShift"/>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
import Textarea from 'primevue/textarea'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'workShift',
  data() {
    return {
      displayBasic: false,
      name: '',
      fromTime: null,
      toTime: null,
      loading: false,
      editing: false,
      workShiftId: null,
      deleteDialog: false,
      filters: {},
      format: {start: '00:00', step: '00:30', end: '12:30', format: 'HH:mm'}
    }
  },
  computed: {
    workShiftList() {
      return this.$store.state.hr.workShiftList
    },
    duration() {
      let diff = parseFloat(this.toTime) - parseFloat(this.fromTime)
      return diff
    }
  },
  mounted() {
    this.findWorkHourList()
  },
  methods: {
    async findWorkHourList() {
      await this.$store.dispatch('loadWorkShiftList')
    },
    async addWorkShift() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let jobTitle = {
        id: this.workShiftId,
        name: this.name,
        startTime: this.fromTime,
        endTime: this.toTime,
        shiftDuration: this.duration
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createWorkShift', jobTitle)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateWorkShift', jobTitle)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    editWorkShift(data) {
      this.editing = true
      this.workShiftId = data.id
      this.name = data.name
      this.duration = data.shiftDuration
      this.toTime = data.endTime
      this.fromTime = data.startTime
      this.openBasic()
    },
    async deleteWorkShift(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let deleteJobTitle = {
        id: this.workShiftId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteWorkShift', deleteJobTitle)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Job Title ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    reset() {
      this.name = ''
      this.fromTime = null
      this.toTime = null
      this.duration = null
      this.displayBasic = false
    },
    openDeleteDialog(id) {
      this.workShiftId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.reset()
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog,
    Textarea,
    DatePicker
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// workShift.vue?256f775d